import React from 'react';
import { StyledSecondaryButton } from 'components/Buttons/styled-component';
import { CoreButtonProps } from 'components/Buttons/CoreButton';

export interface SecondaryButtonProps extends CoreButtonProps {}

const SecondaryButton: React.FC<SecondaryButtonProps> = (
  props,
): JSX.Element => {
  return (
    <StyledSecondaryButton
      id="secondary-button-style"
      background={props.background}
      titleclass="secondary-button-title"
      {...props}
    />
  );
};

export default SecondaryButton;
